export class AuxilioSaudeFormDto{
   meses: number[];
   valor: string;
   codigoPlano: number;
   flTodos: boolean;
}
